module.exports = __webpack_public_path__ + "static/media/wings storyboard.3d93ad5f.png";